import { render, staticRenderFns } from "./Normal.vue?vue&type=template&id=80c2fe40&scoped=true&"
import script from "./Normal.vue.js?vue&type=script&lang=js&"
export * from "./Normal.vue.js?vue&type=script&lang=js&"
import style0 from "./Normal.vue?vue&type=style&index=0&id=80c2fe40&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80c2fe40",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
